// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-select-summary',
    // #endregion
    // #region Properties
    props: {
        schema: {
            type: Object,
            required: false,
            default: undefined,
        },
        schemaData: {
            type: Object,
            required: false,
            default: undefined,
        },
        content: {
            type: Object,
            required: false,
            default: undefined,
        },
        data: {
            type: Object,
            required: false,
            default: undefined,
        },
    },
    data: () => ({}),
    computed: {
        caption() {
            if (!this.element) {
                return null;
            }
            if (this.element.isOptional) {
                return this.element.label + ' (Optional)';
            }
            else {
                return this.element.label;
            }
        },
        element() {
            return this.content?.element;
        },
    },
    // #endregion
    // #region Core
    methods: {
        getValueCaption(value) {
            if (!value) {
                return "--";
            }
            return this.element.options.find((e) => e.value === value)?.label ?? "--";
        }
    }
    // #endregion
});
// #endregion
